import { render } from "./PhysiotherapySessionModal.vue?vue&type=template&id=38d5a2c7&scoped=true"
import script from "./PhysiotherapySessionModal.vue?vue&type=script&lang=js"
export * from "./PhysiotherapySessionModal.vue?vue&type=script&lang=js"

import "./PhysiotherapySessionModal.vue?vue&type=style&index=0&id=38d5a2c7&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d5a2c7"]])

export default __exports__